import { Card, Typography, Button, ProfilePicture } from 'src/components/common';
import cx from './ventureCard.module.scss';
import { test } from 'src/assets/images';
import { useAppSelector } from 'src/store/hooks';
import CoFounderCard from './CoFounderCard';
import { useNavigate } from 'react-router-dom';
import HiringDetailModal from 'src/components/venture/modal/HiringDetailModal';
import { useState } from 'react';
import { useGetIdentity } from 'src/hooks';
import SimilarVentureProfile from './SimilarVentureProfile';
const AboutFounderCard = () => {
  const navigate = useNavigate();
  const { getIdentities } = useGetIdentity();
  const { singleVenture, ventures } = useAppSelector(
    (store) => store.venture
  );
  const { authenticatedId, loggedInUserType } = getIdentities();
  const [hiringDetail, setHiringDetail] = useState(null)
  const coFounders = singleVenture?.CoFounders;
  const hiring = singleVenture?.VentureVerseHirings?.filter((item) => item.title !== 'Co-Founder')
  const coFounderHiring = singleVenture?.VentureVerseHirings?.filter((item) => item.title === 'Co-Founder');
  const similarVentureList = ventures.filter((item) => item.id !== singleVenture?.id);

  function handleView(id: string) {
    navigate(`/view-venture?id=${id}`)
  }
  function handleNavigate(id: string, type: string) {
    if (type === 'user') {
      if (id === authenticatedId) {
        navigate('/my-profile')
      } else {
        navigate(`/view-profile?id=${id}`)
      }
    } else {
      if (id === authenticatedId) {
        navigate('/my-company')
      } else {
        navigate(`/view-company?id=${id}`)
      }
    }
  }
  const modifiedCoFounder = [
    ...(singleVenture?.userId ? [
      { userId: singleVenture?.userId, Company: null, User: singleVenture?.User }
    ] : [
      { userId: null, Company: singleVenture?.Company, User: null }
    ]),
    ...coFounders
  ]

  return (
    <>
      {hiringDetail && <HiringDetailModal title='Hiring Detail' userId={singleVenture?.userId} companyId={singleVenture?.companyId} isModalOpen={hiringDetail?.id} detail={hiringDetail} handleCloseModal={() => setHiringDetail(null)} />}
      {modifiedCoFounder?.length > 0 && <Card className={'action-card'}>
        <Typography as="p" variant="body-1" fontWeight="semiBold">
          About The Founders
        </Typography>{' '}
        {modifiedCoFounder?.map((coFounder, i: number) => {
          return (
            <CoFounderCard coFounder={coFounder} key={i} numCoFounder={singleVenture?.CoFounders?.length} />
          )
        })}
      </Card>}
      {/* co-founder hiring  */}
      {coFounderHiring?.length > 0 && singleVenture?.isSeekingCofounderHiring && <Card className={'action-card'}>
        <Typography as="p" variant="body-1" fontWeight="semiBold">
          <i>{singleVenture?.title}</i> is Hiring
        </Typography>{' '}
        {coFounderHiring?.map((item, i: number) => {
          return (
            <div className={cx.aboutFoundersImage} key={i}>
              <div className={cx.coFounderInner}>
                <ProfilePicture url={item?.logo} fallback={item?.title?.[0]} />
                <div className={cx.coFounderContent}>
                  <h4 title={item.title}>{item.title}</h4>
                  <span title={item.domain}>{item.domain?.split(',')?.join(', ')}</span>
                </div>
              </div>
              <Button variant='primary' size="extraSmall" onClick={() => setHiringDetail(item)}>View</Button>
            </div>
          )
        })}
      </Card>}
      {/*  hiring  */}
      {hiring?.length > 0 && singleVenture?.isHiring && <Card className={'action-card'}>
        <Typography as="p" variant="body-1" fontWeight="semiBold">
        <i>{singleVenture?.title}</i> is Hiring
        </Typography>{' '}
        {hiring?.map((item, i: number) => {
          return (
            <div className={cx.aboutFoundersImage} key={i}>
              <div className={cx.coFounderInner}>
                <ProfilePicture url={item?.logo} fallback={item?.title?.[0]} />
                <div className={cx.coFounderContent}>
                  <h4 title={item.title}>{item.title}</h4>
                  <span title={item.domain}>{item.domain}</span>
                </div>
              </div>
              <Button variant='primary' size="extraSmall" onClick={() => setHiringDetail(item)}>View</Button>
            </div>
          )
        })}
      </Card>}

      {singleVenture?.Likes?.length > 0 && <Card className={'action-card'}>
        <Typography as="p" variant="body-1" fontWeight="semiBold">
          UpVoters
        </Typography>{' '}
        <ul className={cx.upVoterViews}>
          {singleVenture?.Likes?.slice(0, 10)?.map((item, i: number) => {
            const type = item?.userId ? 'user' : 'company';
            const id = item?.userId || item?.Company?.id
            return (
              <li key={i} onClick={() => handleNavigate(id, type)} title={item?.User?.name || item?.Company?.name}> <ProfilePicture style={{ height: "60px", width: '60px' }} fallback={item?.User?.name?.[0] || item?.Company?.name?.[0]} url={item?.User?.profilePic || item?.Compaany?.logo} /></li>
            )
          })}

          {singleVenture?.Likes?.length > 10 && <li className={cx.imageViewbox}> <img src={test} alt="img" />
            <span>+{singleVenture?.Likes?.length - 10}</span></li>}
        </ul>
      </Card>}

      {similarVentureList?.length > 0 && <Card className={'action-card'}>
        <Typography as="p" variant="body-1" fontWeight="semiBold">
          More Ideas like this
        </Typography>{' '}
        <ul className={cx.ideaslikeOuter}>
          {similarVentureList.map((venture) => {
            return (
              <li key={venture.id}>
                <SimilarVentureProfile venture={venture} />
                <Button variant='primary' size="extraSmall" onClick={() => handleView(venture.id)}>View</Button>
              </li>
            )
          })}
        </ul>
      </Card>}

    </>
  );
};

export default AboutFounderCard;
